import { render, staticRenderFns } from "./AddressStep.vue?vue&type=template&id=0cbc08d7"
import script from "./AddressStep.vue?vue&type=script&lang=js"
export * from "./AddressStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports